import { sridsAtom } from '@/atoms';
import { useAtomValue } from 'jotai';

export const useSrids = () => {
  const srids = useAtomValue(sridsAtom);

  return srids;
};
